import { Link, Typography } from "@material-ui/core";
import { useStyles } from "./RestrictedCountryPage.styles";
import { ErrorCard } from "pages/ErrorPage";

export const RestrictedCountryPage = () => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <ErrorCard
        subtitle="Ante is not currently available in your region."
        text={
          <Typography variant={"body1"}>
            You can{" "}
            <Link>
              <a href="https://ante.finance/feedback" rel="noopener">
                drop us a line
              </a>
            </Link>{" "}
            if you believe this is an error.
          </Typography>
        }
      />
    </div>
  );
};
